export default {
  storeUser (user) {
    localStorage.setItem('user', JSON.stringify(user))
  },
  getUser () {
    let userinfo = localStorage.getItem("user")
    if (userinfo != null) {
      return JSON.parse(userinfo)
    } else {
      return {}
    }
  }
}